/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MessageDelete_lists$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageEdit_lists$ref: FragmentReference;
declare export opaque type MessageEdit_lists$fragmentType: MessageEdit_lists$ref;
export type MessageEdit_lists = {|
  +$fragmentRefs: MessageDelete_lists$ref,
  +$refType: MessageEdit_lists$ref,
|};
export type MessageEdit_lists$data = MessageEdit_lists;
export type MessageEdit_lists$key = {
  +$data?: MessageEdit_lists$data,
  +$fragmentRefs: MessageEdit_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageEdit_lists",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MessageDelete_lists"
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '3df6d767cdb26c43d511b5064e97a457';

module.exports = node;
